import { CommonModule } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    inject
} from "@angular/core";

import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { TilbyGesturesDirective } from "@tilby/tilby-ui-lib/directives/tilby-gestures";
import { TilbyCurrencyPipe } from "@tilby/tilby-ui-lib/pipes/tilby-currency";
import { ConfigurationManagerService } from "src/app/core";
import { Items } from "tilby-models";
import { CashregisterStateService } from "src/app/features/cashregister";
import { keyBy } from "src/app/shared/utils";

@Component({
    selector: "app-showcase-grid",
    templateUrl: "./showcase-grid.component.html",
    styleUrls: ["./showcase-grid.component.scss"],
    standalone: true,
    imports: [
        CommonModule,
        MatGridListModule,
        MatIconModule,
        TilbyCurrencyPipe,
        TilbyGesturesDirective
    ]
})
export class ShowcaseGridComponent implements OnChanges, OnInit {
    private readonly configurationManagerService = inject(ConfigurationManagerService);
    private readonly cashregisterStateService = inject(CashregisterStateService);

    private static readonly defaultTileColor = "BBDEFB";

    @Input() itemsSet!: Items[];
    @Input() gridCols = 4;
    @Input() priceList = 1;
    @Input() getStockStatus: Function = () => {};
    @Input() showThumbnail = true;
    @Input() displayMode = "normal";
    @Input() customClass = '';
    @Input() fontNameSize = 12;
    @Input() fontPriceSize = 12;
    @Input() showItemIcon = false;
    @Output() onItemTap: EventEmitter<Items> = new EventEmitter<Items>();
    @Output() onItemPress: EventEmitter<Items> = new EventEmitter<Items>();
    rowHeight : string = '200px';
    priceIdentifier: keyof Items = "price1";
    protected showPrices = this.configurationManagerService.isUserPermitted('show_prices_ui');
    private categoriesById = keyBy(this.cashregisterStateService.categories, (c) => c.id);


    ngOnInit(): void {
        this.rowHeight = this.calculateRowHeight();
        this.priceIdentifier = `price${this.priceList}` as keyof Items;
    }

    itemTap(item: Items): void {
        this.onItemTap.emit(item);
    }

    itemPress(item: Items): void {
        this.onItemPress.emit(item);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.priceList) {
            this.priceIdentifier = `price${changes.priceList.currentValue}` as keyof Items;
        }
        if (changes.displayMode) {
            this.rowHeight = this.calculateRowHeight();
        }

        if(changes.fontNameSize) {
            this.fontNameSize = changes.fontNameSize.currentValue;
        }

        if(changes.fontPriceSize) {
            this.fontPriceSize = changes.fontPriceSize.currentValue;
        }
    }

    calculateRowHeight(): string {
        return this.showThumbnail
            ? this.displayMode === "normal" ? "200px" : "180px"
            : this.displayMode === "normal" ? "90px" : "60px";
    }

    getBackgroundColor(item: Items): string {
        return `#${item.color || this.categoriesById[item.category_id!]?.color || ShowcaseGridComponent.defaultTileColor}`;
    }
}
